import { BuildingColumnKey, type BuildingListColumn } from "./types";

export const BUILDING_LIST_COLUMNS: BuildingListColumn[] = [
  {
    key: BuildingColumnKey.NAME,
    label: "portfolioPage:buildingListColumnBuilding",
    align: "left",
  },
  {
    key: BuildingColumnKey.RATE,
    label: "portfolioPage:buildingListColumnRate",
    align: "right",
  },
  {
    key: BuildingColumnKey.WASTE,
    label: "portfolioPage:buildingListColumnTotalWaste",
    align: "right",
  },
  {
    key: BuildingColumnKey.CONTAMINATION,
    label: "portfolioPage:buildingListColumnContamination",
    align: "right",
  },
  {
    key: BuildingColumnKey.TENANTS,
    label: "portfolioPage:buildingListColumnTenants",
    align: "right",
  },
  {
    key: BuildingColumnKey.STATUS,
    label: "portfolioPage:buildingListColumnStatus",
    align: "left",
  },
];
